import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import TextField from '../../OrderEntry/ui/TextField';
import Select from 'react-select';
import { ClientUser} from '../types';
import axios from 'axios';
import produce from 'immer';
import Button from '../../../components/Button';
import { InfoIcon } from '../../../components/icons';
import ToolTip from '../../OrderEntry/ui/ToolTip';
import { useUserContext } from '../../../context/UserContext';
import ChangePasswordModal from './ChangePasswordModal';

const OuterWrap = styled.div`
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  width: 805px;
  margin: 40px auto;
  padding-bottom: 40px;
  position: relative;
`;
const Header = styled.div`
  font-size: 20px;
  font-weight: 700;
  padding: 32px;
  border-bottom: 1px solid #e5e5ea;
`;
const Section = styled.div`
  padding: 32px;
  border-bottom: 1px solid #e5e5ea;
`;
const SectionHeader = styled.div`
  font-size: 16px;
  font-weight: 700;
  width: 136px;
  margin-right: 16px;
`;
const multiSelectStyles = {
  valueContainer: (provided: any) => ({
    ...provided,
    maxHeight: '200px',
    overflow: 'auto',
    minHeight: 45,
    width: 505,
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided,
    borderRadius: '15px',
    border: '1px solid #f5f5f5',
  }),
};

const AccountSettingsPage = () => {
  const { user } = useUserContext();
  // const [notificationTypes, setNotificationTypes] = useState<DropdownOption[]>([]);
  const [accountInfo, setAccountInfo] = useState<ClientUser>();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [passwordInputValue, setPasswordInputValue] = useState('');

  const getClientInfo = async () => {
    const { data } = await axios.get(`/api/ClientProfile/GetClientContact/${user.id}`);
    setAccountInfo(data);
    getPassWordLength(data.passwordLength || 8);
  };
  const changeAccountInfo = (label: keyof Partial<ClientUser>, value: any) => {
    const newAccountInfo = produce(accountInfo, draft => {
      (draft[label] as any) = value;
      if (label === 'contactNotificationTypes') {
        draft.editedNotificationTypes = true;
      }
    });
    setAccountInfo(newAccountInfo);
  };
  const onSave = async () => {
    await axios.post('/api/ClientProfile/UpdateClientContacts/', accountInfo);
    await getClientInfo();
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
    }, 2000);
  };
  // const getClientNotificationTypes = async () => {
  //   const { data } = await axios.get('/api/ClientProfile/GetClientNotificationTypes');
  //   const mappedData = data.map((d: any) => ({ value: d.id, label: d.notificationType }));
  //   setNotificationTypes(mappedData);
  // };
  const getPassWordLength = (length: number) =>{
    let str = "";
    for(let i = 0; i< length; i++ ){
     str += ' ';
    }
    setPasswordInputValue(str)
  }


  useEffect(() => {
    setLoading(true);
    getClientInfo();
    // getClientNotificationTypes();
    setLoading(false);
  }, [user?.id]);

  return (
    <OuterWrap>
      <Header>My Profile</Header>
      <Section>
        <div style={{ display: 'flex' }}>
          <SectionHeader>Name</SectionHeader>
          <TextField
            name="name"
            label=""
            width="264"
            value={accountInfo?.firstName || ''}
            onChange={e => changeAccountInfo('firstName', e.target.value)}
            styles={{ input: { paddingLeft: 16 }, marginRight: 16 }}
          />
          <TextField
            name="name"
            label=""
            width="264"
            value={accountInfo?.lastName || ''}
            onChange={e => changeAccountInfo('lastName', e.target.value)}
            styles={{ input: { paddingLeft: 16 } }}
          />
        </div>
      </Section>
      <Section>
        <div style={{ display: 'flex' }}>
          <SectionHeader>Email</SectionHeader>
          <TextField
            name="email"
            label=""
            width="540"
            value={accountInfo?.email || ''}
            onChange={e => changeAccountInfo('email', e.target.value)}
            styles={{ input: { paddingLeft: 16 } }}
          />
        </div>
      </Section>
      <Section>
        <div style={{ display: 'flex' }}>
          <SectionHeader>Password</SectionHeader>
          <TextField
            name="password"
            label=""
            width="540"
            value={passwordInputValue}
            styles={{ input: { paddingLeft: 16 } }}
            type="password"
          />
        </div>
        <div
          style={{
            fontSize: 12,
            color: '#8e8e93',
            display: 'flex',
            justifyContent: 'flex-end',
            marginRight: 48,
            cursor: 'pointer',
          }}
          onClick={() => setOpenPasswordModal(true)}
        >
          Change Password
        </div>
      </Section>
      {/* {accountInfo?.clientContactId > 0 && (
        <Section style={{position:'relative'}}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <SectionHeader style={{ alignItems: 'center', display: 'flex' }}>
              Notifications
              <ToolTip
                toolTipText="Send an email notification when there is one of the events listed below"
                wrapOverrides={{ fontSize: 14, color: '#C7C7CC', fontWeight: 'normal' }}
                toolTipOverrides={{ width: 194, height: 85, zIndex: 500, whiteSpace: 'normal', top: -100 }}
              >
                <InfoIcon style={{ marginLeft: 4, cursor: 'pointer' }} />
              </ToolTip>
            </SectionHeader>
            <Select
              // options={notificationTypes}
              value={accountInfo?.contactNotificationTypes}
              onChange={e => changeAccountInfo('contactNotificationTypes', e)}
              styles={multiSelectStyles}
              isMulti
              isClearable={false}
              placeholder={''}
              components={{
                IndicatorSeparator: null,
              }}
            />
          </div>
        </Section>
      )} */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 32, marginRight: 30 }}>
        <div onClick={() => getClientInfo()}>
          <Button buttonText="Cancel" buttonType="ButtonSecondarySmall" />
        </div>
        <div style={{ marginLeft: 8 }}>
          <Button
            buttonText={success ? 'Saved Successfully!' : 'Save changes'}
            loadingStatus={loading}
            width="140px"
            onClick={onSave}
            disabled={loading}
          />
        </div>
      </div>
      {openPasswordModal && (
        <ChangePasswordModal
          open={openPasswordModal}
          onClose={() => setOpenPasswordModal(false)}
          userId={user.id}
          changePasswordUrl={'/api/clientaccount/ChangePassword'}
          confirmPasswordUrl={'/api/clientaccount/MatchUserPassword'}
          handleAfterChange={getClientInfo}
        />
      )}
    </OuterWrap>
  );
};

export default AccountSettingsPage;
